import { useMemo, useState } from 'react';
import {
  useProjectGroupSorting,
  useProjectGroupHeading,
} from 'state/projectGroupSorting';
import { sortProjectData } from 'utils/transforms';
import type { PaginatedProject } from 'types';

export const useSortedProjects = (projects?: any, clientSort: boolean = false) => {
  const { projectGroupSorting: isSorted, setProjectGroupSorting: setSorted } =
    useProjectGroupSorting();
  const { projectGroupHeading: heading, setProjectGroupHeading: setCurrentHeading } =
    useProjectGroupHeading();
  const [sortArray, setSortArray] = useState<string[]>([]);

  const sortedProjects: PaginatedProject[] = useMemo(() => {
    const clonedProjects = projects && [...projects];
    // If there is no heading, return the projects as is
    if (!heading) return clonedProjects;

    if (!isSorted) {
      return sortProjectData(clonedProjects, heading, setSortArray, false, clientSort);
    }

    // Passing boolean 'true' to reverse the sort
    return sortProjectData(clonedProjects, heading, setSortArray, true, clientSort);
  }, [projects, isSorted, heading, clientSort, setSortArray]);

  const sortByHeading = (sortHeading: string) => {
    setSorted((prev) => !prev);
    setCurrentHeading(sortHeading);
  };

  return {
    sortedProjects,
    isSorted,
    sortByHeading,
    heading,
    setCurrentHeading,
    sortArray,
  };
};
